
import Vue from 'vue';

interface Props {
  siteLogo: {
    src: {
      desktop: string | null;
      mobile: string | null;
    };
    url: string | null;
    alt: string;
    logoIsAnimated: boolean;
    logoSize: {
      desktop: {
        width: number;
        height: number;
      };
      mobile: {
        width: number;
        height: number;
      };
    };
  };
}
export default Vue.extend<unknown, unknown, unknown, Props>({
  props: {
    siteLogo: {
      type: Object,
      required: true,
    },
  },
});
